// extracted by mini-css-extract-plugin
export default {"Button":"Gateway_Button__Z7Cwx","alerts":"Gateway_alerts__rLxtk"};